import biz from './biz'
import user from './user'

export default {
  user,
  biz,
  'confirm': '@:terms.confirm',
}
